import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import { CustomCard, CardBody } from "../../../../components/CustomCard";
import { User } from "flowbite-react-icons/outline";
import CustomButton from "../../../../components/CustomButton";

const NoNextMeetingCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <CustomCard className="overflow-visible">
      <CardBody className="p-4 flex flex-col gap-4 overflow-visible">
        <div className="flex flex-col py-4 gap-2 justify-center align-middle items-center">
          <User className="w-8 h-8" aria-hidden="true" />
          <p className="z-body1 text-white whitespace-pre-line text-center">
            {t("select-coach")}
          </p>
        </div>

        <CustomButton
          buttonType="blueBase"
          onClick={() => navigate("/videocoach/match-with-coach")}
        >
          {t("match-with-coach")}
        </CustomButton>
      </CardBody>
    </CustomCard>
  );
};

export default NoNextMeetingCard;
